import {injectable} from "inversify";

import "@/extensions/date.extensions";
import {ApiService} from "@/services/apiService";
import {IAddressService} from "@/injection/interfaces";
import {IFilterAddressesRequest, IGetAddressRequest} from "@/types/requests";
import {IFilterAddressesResponse, IGetAddressResponse} from "@/types/responses";
import {AxiosError, AxiosResponse} from "axios";
import {Book} from "@/types";

@injectable()
export class AddressService extends ApiService implements IAddressService {
  public async filterAddresses(request: IFilterAddressesRequest): Promise<IFilterAddressesResponse> {
    const params = `street=${request.street}&language=${request.language}`
    const response = await this
      ._httpClient
      .get<AxiosResponse<Book[]>>(`${process.env.VUE_APP_API_BASE_URL}/api/addresses/filter?${params}`)
      .catch(function (error: AxiosError): AxiosResponse<IFilterAddressesResponse> {
        return error.response as AxiosResponse<IFilterAddressesResponse>
      })
    return response.data as IFilterAddressesResponse
  }

  public async getAddress(request: IGetAddressRequest): Promise<IGetAddressResponse> {
    const params = `language=${request.language}`
    const response = await this
      ._httpClient
      .get<AxiosResponse<Book[]>>(`${process.env.VUE_APP_API_BASE_URL}/api/addresses/${request.id}?${params}`)
      .catch(function (error: AxiosError): AxiosResponse<IGetAddressResponse> {
        return error.response as AxiosResponse<IGetAddressResponse>
      })
    return response.data as IGetAddressResponse
  }
}